import React, { memo, forwardRef } from "react";
const SvgComplexConjugate = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <rect width={10} height={14} x={11} y={11} fill="#DBDBDB" rx={2} />
      <path
        stroke="#717171"
        strokeLinecap="round"
        strokeWidth={2}
        d="M21 8H11"
      />
    </svg>
  );
});
SvgComplexConjugate.displayName = "SvgComplexConjugate";
const MemoForwardRef = memo(SvgComplexConjugate);
export default MemoForwardRef;
